import PropTypes from 'prop-types'

import styles from './TextInput.module.scss'

const TextArea = ({
  type = 'text',
  label,
  className,
  valid,
  children,
  forwardedRef,
  value,
  onChangeValue,
  ...props
}) => (
  <label className={[styles.container, className ? className : ''].join(' ')}>
    {label && <span className={styles.label}>{label}</span>}
    <textarea
      className={[
        styles.input,
        valid === true ? styles.inputSuccess : '',
        valid === false ? styles.inputError : ''
      ].join(' ')}
      ref={forwardedRef}
      onChange={e => onChangeValue(e.target.value)}
      {...props}
      autoComplete="off"
      type={type}
      value={typeof value !== 'undefined' ? value : undefined}
    />
    {children}
  </label>
)

TextArea.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  succeded: PropTypes.bool,
  errored: PropTypes.bool
}

export default TextArea
